import SbAnchor from '@src/components/Anchor/SbAnchor.vue';
import SbDataTable from '@src/components/Table/next/SbDataTable.vue';
import SbAccordion from '@src/components/Accordion/SbAccordion.vue';
import SbStepper from '@src/components/Stepper/SbStepper.vue';
import SbActionList from '@src/components/ActionList/SbActionList.vue';
import SbAction from '@src/components/ActionList/components/SbAction.vue';
import SbActions from '@src/components/ActionList/components/SbActions.vue';
import SbEmptyActions from '@src/components/ActionList/components/SbEmptyActions.vue';
import SbActionListEmptyOptions from '@src/components/ActionList/components/SbEmptyOptions.vue';

import SbBackLink from '@src/components/BackLink/SbBackLink.vue';

import SbBadge from '@src/components/Badge/SbBadge.vue';

import SbBanner from '@src/components/Banner/SbBanner.vue';

import SbButton from '@src/components/Button/SbButton.vue';

import SbCheckbox from '@src/components/Checkbox/SbCheckbox.vue';

import SbChip from '@src/components/Chip/SbChip.vue';

import SbClipboard from '@src/components/Clipboard/SbClipboard.vue';

import SbDraggable from '@src/components/Draggable/SbDraggable.vue';
import SbDrawer from '@src/components/Drawer/SbDrawer.vue';

import SbDropdown from '@src/components/Dropdown/SbDropdown.vue';
import SbDropdownSearch from '@src/components/Dropdown/SbDropdownSearch.vue';
import SbDropdownOption from '@src/components/Dropdown/SbDropdownOption.vue';
import SbSelectedDropdownSearchOption from '@src/components/Dropdown/SbSelectedDropdownSearchOption.vue';
import SbOption from '@src/components/Dropdown/components/SbOption.vue';
import SbOptions from '@src/components/Dropdown/components/SbOptions.vue';
import SbSelectedOption from '@src/components/Dropdown/components/SbSelectedOption.vue';
import SbDropdownEmptyOptions from '@src/components/Dropdown/components/SbEmptyOptions.vue';

import SbEllipsis from '@src/components/Ellipsis/SbEllipsis.vue';

import SbField from '@src/components/Field/SbField.vue';
import SbFieldHelperText from '@src/components/Field/components/SbFieldHelperText.vue';

import SbFileUpload from '@src/components/FileUpload/SbFileUpload.vue';

import SbFilterBar from '@src/components/Filter/SbFilterBar.vue';
import SbFilterChips from '@src/components/Filter/SbFilterChips.vue';
import SbFiltersActivator from '@src/components/Filter/components/SbFiltersActivator.vue';
import SbFilterSearch from '@src/components/Filter/components/SbFilterSearch.vue';
import SbFilterWrapper from '@src/components/Filter/SbFilterWrapper.vue';

import SbFlexWrapped from '@src/components/FlexWrapped/SbFlexWrapped.vue';

import SbForm from '@src/components/Form/SbForm.vue';

import CheckmarkIcon from '@src/components/Icons/components/CheckmarkIcon.vue';
import CircleIcon from '@src/components/Icons/components/CircleIcon.vue';
import DangerousIcon from '@src/components/Icons/components/DangerousIcon.vue';
import EyeIcon from '@src/components/Icons/components/EyeIcon.vue';
import PackageVerifiedIcon from '@src/components/Icons/components/PackageVerifiedIcon.vue';
import PadlockIcon from '@src/components/Icons/components/PadlockIcon.vue';
import UpgradedIcon from '@src/components/Icons/components/UpgradedIcon.vue';
import SbIcon from '@src/components/Icons/SbIcon.vue';
import Icon from '@src/components/Icons/Icon.vue';
import SbSvgIcon from '@src/components/Icons/components/SbSvgIcon.vue';

import SbNumberInput from '@src/components/Input/SbNumberInput.vue';
import SbTextInput from '@src/components/Input/SbTextInput.vue';
import SbBarcodeInputProgress from '@src/components/Input/SbBarcodeInputProgress.vue';
import SbTextarea from '@src/components/Input/SbTextArea.vue';
import SbBarcodeInput from '@src/components/Input/SbBarcodeInput.vue';

import IntersectionObserver from '@src/components/IntersectionObserver/IntersectionObserver.vue';

import SbKeyValueGroup from '@src/components/KeyValue/SbKeyValueGroup.vue';
import SbKeyValue from '@src/components/KeyValue/SbKeyValue.vue';
import SbKeyValueContainer from '@src/components/KeyValue/components/SbKeyValueContainer.vue';

import SbLabel from '@src/components/Label/SbLabel.vue';

import SbLoadingSpinner from '@src/components/Loading/SbLoadingSpinner.vue';
import Splash from '@src/components/Loading/Splash.vue';
import SbLoadingPromiseWrapper from '@src/components/Loading/SbLoadingPromiseWrapper.vue';

import SbMasonry from '@src/components/Masonry/SbMasonry.vue';
import SbMasonryItem from '@src/components/Masonry/components/SbMasonryItem.vue';

import SbModal from '@src/components/Modal/SbModal.vue';

import SbPanel from '@src/components/Panel/SbPanel.vue';

import SbPaginationLink from '@src/components/Pagination/SbPaginationLink.vue';
import SbPaginationText from '@src/components/Pagination/SbPaginationText.vue';
import SbPaginationInput from '@src/components/Pagination/components/SbPaginationInput.vue';
import SbPaginationLinks from '@src/components/Pagination/components/SbPaginationLinks.vue';

import SbProgressBar from '@src/components/ProgressBar/SbProgressBar.vue';

import SbPopover from '@src/components/Popover/SbPopover.vue';

import SbRadioButton from '@src/components/RadioButton/SbRadioButton.vue';

import ResizeObserver from '@src/components/ResizeObserver/ResizeObserver.vue';

import SbStatus from '@src/components/Status/SbStatus.vue';

import SbStickyElement from '@src/components/StickyElement/SbStickyElement.vue';

import SbSwitch from '@src/components/Switch/SbSwitch.vue';
import SbButtonGroupSwitch from '@src/components/Switch/SbButtonGroupSwitch.vue';

import SbTableExpandableRows from '@src/components/Table/SbTableExpandableRows.vue';
import SbEmptyState from '@src/components/Table/components/SbEmptyState.vue';
import SbSortableTableHead from '@src/components/Table/components/SbSortableTableHead.vue';
import SbTableCell from '@src/components/Table/components/SbTableCell.vue';
import SbTableHead from '@src/components/Table/components/SbTableHead.vue';
import SbTableRow from '@src/components/Table/components/SbTableRow.vue';
import SbTableRowPasser from '@src/components/Table/components/SbTableRowPasser.vue';
import SbTableThead from '@src/components/Table/components/SbTableThead.vue';
import SbTableEmptyState from '@src/components/Table/SbTableEmptyState.vue';

import SbTabsList from '@src/components/Tabs/SbTabsList.vue';
import SbTab from '@src/components/Tabs/components/SbTab.vue';

import SbText from '@src/components/Text/SbText.vue';

import SbTimeContent from '@src/components/Timeline/SbTimeContent.vue';
import SbTimeLabel from '@src/components/Timeline/SbTimeLabel.vue';
import SbTimeline from '@src/components/Timeline/SbTimeline.vue';
import SbVerticalTimeline from '@src/components/Timeline/SbVerticalTimeline.vue';
import SbProgressBarBreakPoint from '@src/components/Timeline/components/SbProgressBarBreakPoint.vue';

import SbTooltip from '@src/components/Tooltip/SbTooltip.vue';

import SlideTransition from '@src/components/Transitions/Slide.vue';
import FadePopTransition from '@src/components/Transitions/FadePop.vue';
import FadeTransition from '@src/components/Transitions/Fade.vue';
import ExpandTransition from '@src/components/Transitions/Expand.vue';

import SbDatePicker from '@src/components/DatePicker/SbDatePicker.vue';
import SbCountryFlag from '@src/components/CountryFlag/SbCountryFlag.vue';

// // /** ***************
// //  * Layout
// //  * *************** */
import SbDetailsTemplate from '@src/layout/Details/SbDetailsTemplate.vue';
import SbPageHeader from '@src/layout/PageHeader/SbPageHeader.vue';

import SbTemplate from '@src/layout/Header/SbTemplate.vue';
import SbTemplateHeader from '@src/layout/Header/SbTemplateHeader.vue';
import SbTemplateHeaderItem from '@src/layout/Header/SbTemplateHeaderItem.vue';

import SbPage from '@src/layout/Page/SbPage.vue';

import NavBar from '@src/layout/NavBar/NavBar.vue';

import SbToolbar from '@src/layout/Toolbar/SbToolbar.vue';

// /** ***************
//  * Pages
//  * *************** */

import SbSelect from '@src/components/Select/SbSelect.vue';

import SbAutoComplete from '@src/components/AutoComplete/SbAutoComplete.vue';
import AnalyticsMixin from '@src/telemetry/mixin';
import SbDataTableCell from '@src/components/Table/next/components/SbDataTableCell.vue';
import SbMultiSelect from '@src/components/Multiselect/SbMultiselect.vue';
import SbColumnsDrawer from '@src/components/Filter/next/components/SbColumnsDrawer.vue';
import SbFiltersDrawer from '@src/components/Filter/next/components/SbFiltersDrawer.vue';
import SbFilterOptions from '@src/components/Filter/next/components/SbFilterOptions.vue';

export function withAnalyticsMixin(component) {
  const existingMixins = component.mixins || [];

  return {
    ...component,
    mixins: [...existingMixins, AnalyticsMixin],
  };
}

export const getComponentsList = (options = {}) => ({
  SbAutoComplete,
  SbAccordion,
  SbStepper,
  SbSelect,
  SbDataTable,
  [SbDataTableCell.name]: SbDataTableCell,
  SbActionList,
  [SbAction.name]: SbAction,
  [SbActions.name]: SbActions,
  [SbEmptyActions.name]: SbEmptyActions,
  [SbActionListEmptyOptions.name]: SbActionListEmptyOptions,
  [SbAnchor.name]: SbAnchor,
  [SbBackLink.name]: SbBackLink,
  [SbBadge.name]: SbBadge,
  [SbBanner.name]: SbBanner,
  SbButton,
  SbCheckbox,
  SbChip,
  [SbClipboard.name]: SbClipboard,
  SbDatePicker,
  [SbDrawer.name]: SbDrawer,
  [SbDropdown.name]: SbDropdown,
  [SbDropdownSearch.name]: SbDropdownSearch,
  [SbDropdownOption.name]: SbDropdownOption,
  [SbDropdownEmptyOptions.name]: SbDropdownEmptyOptions,
  [SbOption.name]: SbOption,
  [SbOptions.name]: SbOptions,
  [SbSelectedDropdownSearchOption.name]: SbSelectedDropdownSearchOption,
  [SbSelectedOption.name]: SbSelectedOption,
  [SbEllipsis.name]: SbEllipsis,
  [SbField.name]: SbField,
  [SbFieldHelperText.name]: SbFieldHelperText,
  [SbFileUpload.name]: SbFileUpload,
  [SbFilterBar.name]: SbFilterBar,
  [SbFilterChips.name]: SbFilterChips,
  [SbFilterOptions.name]: SbFilterOptions,
  [SbFilterSearch.name]: SbFilterSearch,
  [SbFiltersActivator.name]: SbFiltersActivator,
  [SbFilterSearch.name]: SbFilterSearch,
  SbFilterWrapper,
  [SbFlexWrapped.name]: SbFlexWrapped,
  [SbForm.name]: SbForm,
  [CheckmarkIcon.name]: CheckmarkIcon,
  [CircleIcon.name]: CircleIcon,
  [DangerousIcon.name]: DangerousIcon,
  [EyeIcon.name]: EyeIcon,
  [PackageVerifiedIcon.name]: PackageVerifiedIcon,
  [PadlockIcon.name]: PadlockIcon,
  [UpgradedIcon.name]: UpgradedIcon,
  [SbIcon.name]: SbIcon,
  [Icon.name]: Icon,
  [SbSvgIcon.name]: SbSvgIcon,
  SbNumberInput,
  SbTextInput,
  [SbBarcodeInputProgress.name]: SbBarcodeInputProgress,
  SbTextarea,
  [SbBarcodeInput.name]: SbBarcodeInput,
  [IntersectionObserver.name]: IntersectionObserver,
  [SbKeyValueGroup.name]: SbKeyValueGroup,
  [SbKeyValueContainer.name]: SbKeyValueContainer,
  [SbKeyValue.name]: SbKeyValue,
  [SbLabel.name]: SbLabel,
  [SbLoadingSpinner.name]: SbLoadingSpinner,
  [Splash.name]: Splash,
  [SbLoadingPromiseWrapper.name]: SbLoadingPromiseWrapper,
  [SbMasonry.name]: SbMasonry,
  [SbMasonryItem.name]: SbMasonryItem,
  SbModal,
  SbPanel,
  [SbPaginationInput.name]: SbPaginationInput,
  [SbPaginationLink.name]: SbPaginationLink,
  [SbPaginationLinks.name]: SbPaginationLinks,
  [SbPaginationText.name]: SbPaginationText,
  [SbProgressBar.name]: SbProgressBar,
  [SbPopover.name]: SbPopover,
  SbRadioButton,
  [ResizeObserver.name]: ResizeObserver,
  [SbStatus.name]: SbStatus,
  [SbStickyElement.name]: SbStickyElement,
  [SbTableExpandableRows.name]: SbTableExpandableRows,
  [SbEmptyState.name]: SbEmptyState,
  [SbSortableTableHead.name]: SbSortableTableHead,
  [SbTableCell.name]: SbTableCell,
  [SbTableHead.name]: SbTableHead,
  [SbTableRow.name]: SbTableRow,
  [SbTableRowPasser.name]: SbTableRowPasser,
  [SbTableThead.name]: SbTableThead,
  [SbTableEmptyState.name]: SbTableEmptyState,
  SbTabsList,
  SbTab,
  [SbText.name]: SbText,
  [SbTimeContent.name]: SbTimeContent,
  [SbTimeLabel.name]: SbTimeLabel,
  [SbTimeline.name]: SbTimeline,
  [SbVerticalTimeline.name]: SbVerticalTimeline,
  [SbProgressBarBreakPoint.name]: SbProgressBarBreakPoint,
  [SbTooltip.name]: SbTooltip,
  [SlideTransition.name]: SlideTransition,
  [FadePopTransition.name]: FadePopTransition,
  [FadeTransition.name]: FadeTransition,
  [ExpandTransition.name]: ExpandTransition,
  [SbDetailsTemplate.name]: SbDetailsTemplate,
  [SbPageHeader.name]: SbPageHeader,
  [SbTemplate.name]: SbTemplate,
  [SbTemplateHeader.name]: SbTemplateHeader,
  [SbTemplateHeaderItem.name]: SbTemplateHeaderItem,
  [NavBar.name]: NavBar,
  [SbToolbar.name]: SbToolbar,
  [SbSwitch.name]: SbSwitch,
  [SbButtonGroupSwitch.name]: SbButtonGroupSwitch,
  [SbDraggable.name]: SbDraggable,
  SbPage,
  SbCountryFlag,
  SbMultiSelect,
  SbColumnsDrawer,
  SbFiltersDrawer,
});
